import HotlinkMenuItem from "components/framework/Hotlink";
import Icons, { CUSTOM_ICONS } from "components/images/Icons";
import { getUrl, IMenuItem } from "lib/types/sanity";
import { Hotlink } from 'lib/types/Settings';
import Link from "next/link";
import { Dispatch, SetStateAction } from "react";

import classNames from "classnames";
import styles from "./DropDownMenu.module.css";




//#region [Props]
type DropDownMenuProps = {
    isOpen: boolean;
    menuItems?: IMenuItem[];
    hotlinks?: Hotlink[];
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    useAnchors?: boolean;
};



//#endregion

//#region [Component]
export default function DropDownMenu({ setIsOpen, isOpen = false, menuItems, hotlinks, useAnchors = false }: DropDownMenuProps) {
    if (!menuItems || menuItems.length === 0) {
        return null;
    }
    return <nav className={classNames(styles.Nav, isOpen ? styles.Nav_isOpen : null)} onClick={() => setIsOpen(false)}>
        <ul>
            {hotlinks?.map(hotlink => {
                return <li className={classNames(styles.HotLinkListItem, !!hotlink.alwaysShowInDropdown ? null : styles.HotLinkListItem_neverShowInDropdown)} key={hotlink._key} ><HotlinkMenuItem hotlink={hotlink} useAnchors={useAnchors} /></li>
            })}
            {menuItems.map((menuItem => {
                const url = getUrl(menuItem);
                if (!url) {
                    return null;
                }
                return <li key={menuItem._key}><Link href={url}><MenuIcon menuItem={menuItem} /> {menuItem.title}</Link></li>
            }))}
        </ul>
    </nav>
}
//#endregion

//#region [Props]
type MenuIconProps = {
    menuItem: IMenuItem;
};
//#endregion

//#region [Component]
function MenuIcon({ menuItem }: MenuIconProps) {
    if (menuItem.customIcon) {
        return CUSTOM_ICONS[menuItem.customIcon!];
    }
    if (menuItem.icon) {
        return Icons[menuItem.icon!];
    }
    return null;
}
//#endregion